import React, { FunctionComponent, useEffect, useState } from 'react'
import { getForumSearchResult } from 'Frontend/scripts/services/forums.service'
import { IForumSearchResults, ISelectOption } from 'Frontend/scripts/models/forums.model'
import { Button } from 'react-bootstrap'
import MultiSelectComponent from 'Features/MultiSelectComponent/MultiSelectComponent'
import { useTranslation } from 'react-i18next'

interface SearchFormProps {
  query?: string
  tags?: ISelectOption[]
  callback: (_searchData: IForumSearchResults) => void | null
}

const SearchForm: FunctionComponent<SearchFormProps> = ({ query, tags, callback }) => {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)
  const [searchQuery, setSearchQuery] = useState<string>(
    params.has('query')
      ? url.searchParams?.get('query') !== null
        ? (url?.searchParams?.get('query') as string)
        : query?.length != 0
          ? (query as string)
          : ''
      : '',
  )
  const { t } = useTranslation()

  const tagsFromUrl = params.get('tags')?.split(',') ?? []

  const [selectedTags, setSelectedTags] = useState<string[]>(tagsFromUrl)

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault()
    getForumSearchResult(searchQuery, 1, selectedTags).then((data: IForumSearchResults) => {
      url.searchParams.set('query', searchQuery as string)
      url.searchParams.set('page', '1')
      url.searchParams.set('tags', selectedTags.join(','))
      window.history.pushState({}, '', url)
      callback(data)
    })
  }

  useEffect(() => {
    handleSubmit()
  }, [selectedTags])

  return (
    <div className="mb-4 forums__search">
      <h2 className="forums__heading">{t('search-in-forum')}</h2>
      <form method="post" onSubmit={handleSubmit} className="hero__search-field">
        <div className="d-flex gap-3">
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              name="query"
              defaultValue={searchQuery as string}
              aria-label="Sökformulär"
              aria-describedby="id-search-button"
              onChange={(e) => setSearchQuery(e.target.value)}
            ></input>
            <Button variant="secondary" type="submit" className="forums__search-button" id="id-search-button">
              <i className="fa fa-search me-2"></i>
              {t('search')}
            </Button>
          </div>
        </div>
        {tags && tags.length > 0 && (
          <div className="mt-3">
            <h3 className="mb-2 h4">{t('questions-tagged-with')}:</h3>
            <MultiSelectComponent
              options={tags}
              addToUrl={true}
              onChange={(selectedTagIds) => {
                const isSelectedTags = selectedTagIds.map((item: ISelectOption) => item.value.toString())
                setSelectedTags(isSelectedTags)
              }}
            />
          </div>
        )}
      </form>
    </div>
  )
}

export default SearchForm
